import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/core.scss';
import css from './index.scss';
import Badge from '../../badge/index';

const YearGroupFormatter = ({ dependentValues }) => {
    const yearStyle = `yg${dependentValues.yearGroupEnum}`;
    return (
        <Badge badgeStyle={`${css.yearGroup} ${yearStyle}`} content={dependentValues.year} />
    );
};

YearGroupFormatter.propTypes = {
    dependentValues: PropTypes.object
};

export default YearGroupFormatter;



// WEBPACK FOOTER //
// ./app/components/formatters/year-group-formatter/index.js